export const PasswordPattern = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;
export const NoSpacePattern = /^\S*$/g;
export const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const NoSpaceNamePattern = /^(\w+\s)*\w+$/;

export const InstagramUsernamePatter = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]*$/;

export const UsernameAllowedChars = /^[A-Za-z0-9_.]+$/g;

// socials
export const facebookProfileLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w-]*)?/;
export const instagramProfileLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www.)?(?:instagram\.com|instagr\.am)\/(?<username>[A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.)))(?:[A-Za-z0-9_]))?)/;
export const snapchatProfileLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www.)?snapchat\.com\/add\/(?<username>[A-z0-9._-]+)\/?/;
export const twitterUserLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www\.)?(?:twitter|x)\.com\/@?(?!home|share|privacy|tos)(?<username>[A-Za-z0-9_]+)\/?$/;

export const tiktokRegExp =
  /^(?:(?:http|https):\/\/)?(?:www.)?tiktok\.com\/@((?!.*\.\.)(?!.*\.$)[^\W][\w.])/;
export const youtubeChannelLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www\.)?youtube\.com\/@(?<id>[A-z0-9-_]+)\/?/;
export const twitchChannelLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
export const linkedInLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www.)?linkedin\.com\/in\/(?<permalink>[\w\-_À-ÿ%]+)\/?/;
export const soundCloudLinkRegExp =
  /^(?:(?:http|https):\/\/)?(?:www.)?(m\.)?soundcloud\.com\/[\w\-.]+\/?$/;
